<template>
  <div class="ck-social-wrap">
    <ul class="ck-social" :class="{ 'ck-social--lg': size === 'lg' }">
      <li v-for="item in items" :key="item.name">
        <router-link v-if="item.to" :to="item.to" :aria-label="item.label" :title="captions ? null : item.label"
          @mouseenter="hover(item)" @mouseleave="hover(null)" @focus="hover(item)" @blur="hover(null)"><CkIcon :name="item.name" /></router-link>
        <a v-else :href="item.href" :aria-label="item.label" :title="captions ? null : item.label" :target="item.external ? '_blank' : null" :rel="item.external ? 'me noopener' : null"
          @mouseenter="hover(item)" @mouseleave="hover(null)" @focus="hover(item)" @blur="hover(null)"><CkIcon :name="item.name" /></a>
      </li>
    </ul>
    <p v-if="captions" class="ck-social__caption" :class="{ 'is-on': current }" aria-hidden="true">
      <span class="ck-social__caption-rule"></span>
      <span class="ck-social__caption-text">{{ current ? current.label : last }}</span>
      <span class="ck-social__caption-rule"></span>
    </p>
  </div>
</template>

<script>
import CkIcon from '@/components/ui/CkIcon.vue';

// The one list of ways to reach me, drawn as glyphs only. With `captions`, the hovered channel's name is written
// out beneath the row (the accessible name is on the link either way).
const CHANNELS = [
  { name: 'github', label: 'GitHub', href: 'https://github.com/chankov', external: true },
  { name: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/in/nikolay-chankov/', external: true },
  { name: 'x', label: 'X', href: 'https://x.com/twsbg', external: true },
  { name: 'mail', label: 'Email', href: 'mailto:nchankov@outlook.com' },
  { name: 'goodreads', label: 'Goodreads', href: 'https://www.goodreads.com/user/show/81916230-nikolay-chankov', external: true },
  { name: 'rss', label: 'RSS', href: '/rss.xml' }
];

export default {
  name: 'SocialLinks',
  components: { CkIcon },
  props: {
    size: { type: String, default: 'md' }, // md · lg
    contact: { type: Boolean, default: false }, // append a glyph that leads to the contact form
    captions: { type: Boolean, default: false }
  },
  data() {
    return { current: null, last: '' };
  },
  computed: {
    items() {
      return this.contact
        ? [...CHANNELS, { name: 'comment', label: 'Contact form', to: { name: 'index', hash: '#contact' } }]
        : CHANNELS;
    }
  },
  methods: {
    hover(item) {
      if (item) this.last = item.label;
      this.current = item;
    }
  }
}
</script>
